import { TransactionState, Transaction } from './types';

export const transactionsSet = (
  state: TransactionState,
  transactions: Transaction[],
): void => {
  state.transactions = transactions;
};
